// Helpers de debug do motor de precisão.
// Expostos em window.__norm em modo dev para inspeção rápida via console.

import { aggregatePrecisionTelemetry } from "./precisionTelemetryAggregate";

function pct(n) {
  if (!Number.isFinite(n)) return "—";
  return (n * 100).toFixed(1) + "%";
}

function ms(n) {
  if (!Number.isFinite(n) || n === null) return "—";
  return n + "ms";
}

/**
 * Formata agregado em string legível para terminal/console.
 */
export function formatPrecisionStats(agg) {
  if (!agg || agg.totalRuns === 0) {
    return "Sem runs registrados (precisa de uso real com aiTelemetryEnabled).";
  }
  const lines = [];
  lines.push(`Runs totais: ${agg.totalRuns}`);
  lines.push(`Escalados:   ${agg.escalatedCount} (${pct(agg.escalationRate)})`);
  lines.push(`Truncados:   ${agg.truncatedCount ?? 0} (${pct(agg.truncationRate ?? 0)})`);
  lines.push(`Latência:    avg ${ms(agg.avgLatencyMs)} | esc ${ms(agg.avgLatencyEscalatedMs)} | non-esc ${ms(agg.avgLatencyNonEscalatedMs)}`);
  if (agg.avgOutputTokens != null) lines.push(`Output avg:  ${agg.avgOutputTokens} tokens`);
  if (agg.avgContextChars != null) lines.push(`Context avg: ${agg.avgContextChars} chars`);
  if (agg.cacheHitRate != null) lines.push(`Cache hit:   ${pct(agg.cacheHitRate)}`);

  const sigs = Object.entries(agg.signalFrequency).sort((a, b) => b[1] - a[1]);
  if (sigs.length > 0) {
    lines.push("Sinais (frequência):");
    for (const [k, v] of sigs) lines.push(`  - ${k}: ${v}`);
  }

  const mods = Object.entries(agg.byModule).sort((a, b) => b[1].runs - a[1].runs);
  if (mods.length > 0) {
    lines.push("Por módulo:");
    for (const [k, v] of mods) lines.push(`  - ${k}: ${v.runs} runs, ${v.escalated} escalados (${pct(v.rate)})`);
  }

  const models = Object.entries(agg.byModel).sort((a, b) => b[1] - a[1]);
  if (models.length > 0) {
    lines.push("Por modelo:");
    for (const [k, v] of models) lines.push(`  - ${k}: ${v}`);
  }

  return lines.join("\n");
}

/**
 * Registra helpers em window.__norm (dev). No-op fora de dev.
 *
 * Uso no console:
 *   __norm.precisionStats()  → string formatada
 *   __norm.precisionRaw()    → objeto agregado bruto
 *   __norm.precisionLog()    → entries ai_run_meta crus
 */
export function registerPrecisionDebug({ getLog }) {
  if (typeof window === "undefined") return;
  if (!import.meta.env || !import.meta.env.DEV) return;

  const w = window;
  w.__norm = w.__norm || {};
  w.__norm.precisionRaw = () => aggregatePrecisionTelemetry(getLog());
  w.__norm.precisionStats = () => {
    const out = formatPrecisionStats(aggregatePrecisionTelemetry(getLog()));
    console.log(out);
    return out;
  };
  w.__norm.precisionLog = () => getLog().filter(e => e && e.action === "ai_run_meta");
}
